import { Suspense } from "react";

import { Box } from "@mui/material";
import * as Sentry from "@sentry/react";
import { Outlet } from "react-router-dom";

import Nav from "../app/Nav";
import BoundaryFallback from "./BoundaryFallback";
import { RouteLoading } from "./Loading";
import HelpChatWidget from "../help-chat/HelpChatWidget";

import type { IAeronetNav } from "../app/types";

interface AppLayoutProps {
  nav: readonly IAeronetNav[];
}

const AppLayout: React.FC<AppLayoutProps> = ({ nav }) => {
  return (
    <Box textAlign="center" sx={{ backgroundColor: "white" }} data-testid="app" height="100%">
      <Nav nav={nav} />
      <Sentry.ErrorBoundary fallback={(props) => <BoundaryFallback {...props} />}>
        <Suspense fallback={<RouteLoading />}>
          <Outlet />
        </Suspense>
      </Sentry.ErrorBoundary>
      {/* Mounted once here so the help chat persists across navigation; it
          renders the button only on help-menu routes (see HelpChatWidget). */}
      <HelpChatWidget />
    </Box>
  );
};

export default AppLayout;
